.section {
  position: relative;
  overflow: hidden;
  padding: 7rem 2rem;
  background: #0e1319;
  color: #f3f4f6;
}

.backdrop {
  position: absolute !important;
  inset: 0;
}

.container {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 74rem;
  margin: 0 auto;
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem 3rem;
  margin-bottom: 3rem;
}

.heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
}

.guide {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-weight: 500;
}

.title {
  margin: 0;
}

// The six kinds of input, as a row of icons: the header's one line.
.inputs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 0.9375rem;
  font-weight: 500;

  li {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
}

@media (max-width: 640px) {
  .section {
    padding: 5rem 1.25rem;
  }

  .header {
    margin-bottom: 2.5rem;
  }

}
